import React from 'react';
import styles from './fitSliderStyles.module.scss';

const FitSlider = ({ averageRating, fitRange }: { averageRating: number; fitRange: number }) => {
  const fitLabels = ['Runs small', 'True to size', 'Runs large'];
  const sliderPosition = ((averageRating - 1) * 100) / (fitRange - 1) + '%';

  return (
    <div className={`${styles.fitSlider} user-fit-slider`}>
      <div className={styles.fitLabels}>
        {fitLabels.map((label, idx) => (
          <span key={idx} className="body semibold notranslate">
            {label}
          </span>
        ))}
      </div>
      <div className={styles.sliderWrapper}>
        <div className={styles.slider} style={{ left: sliderPosition }} />
        <span className={styles.verticalLine}></span>
        <span className={styles.verticalLine}></span>
        <span className={styles.verticalLine}></span>
      </div>
    </div>
  );
};

export default FitSlider;
